import $store from "@/store";
import $router from "@/router";
import Vue from "vue";
import { i18n } from "@/main.js";
import $h from "@/assets/js/helpers.js";

const errors = {
  handle: (err, data = {}) => {
    if (err) {
      if (err.status === 401) {
        if (err.data && err.data.error && err.data.error.code === "GEN-PASSWORD-EXPIRED") {
          data.logoutAllTeams = true;
          if ($router.currentRoute.params.teamSlug) {
            data.redirect = $router.currentRoute.params.teamSlug + "/pwexpired";
          } else if ($router.currentRoute.params.team) {
            data.team = $router.currentRoute.params.team;
            data.redirect = $store.getters.auth_get_teams[$router.currentRoute.params.team].team.slug + "/pwexpired";
          }
          $store.dispatch("logout", data);
        } else {
          if ($router.currentRoute.name !== "Login") {
            $store.dispatch("logout", data);
          }
        }
      }
      if (err.status === 403) {
        const modal = {
          body: i18n.t("modals.genericUnauthorizedError.text"),
          title: i18n.t("modals.genericUnauthorizedError.title"),
        };
        if (err.data && err.data.error && err.data.error.code === "GEN-TEAM-SUBSCRIPTION-REQUIRED") {
          $router.push({ name: "TeamSubscription" });
        } else {
          let owner = false;
          if (
            $router.currentRoute.params.team &&
            $store.getters.auth_get_teams[$router.currentRoute.params.team] &&
            $store.getters.auth_get_teams[$router.currentRoute.params.team].account.role.includes("owner")
          ) {
            owner = true;
          }
          if (err.data && err.data.error && err.data.error.code === "GEN-TEAM-PERMISSION-MISSING") {
            if (owner) {
              modal.body = i18n.t("modals.errorTeamPermissionMissing.text.owner");
              modal.title = i18n.t("modals.errorTeamPermissionMissing.title");
              modal.secondaryButtonCb = () => {
                return $h.goTo("Settings", { tab: "team", scroll: true });
              };
              modal.secondaryButtonText = i18n.t("actions.manageSubscription");
            } else {
              modal.body = i18n.t("modals.errorTeamPermissionMissing.text.user");
              modal.title = i18n.t("modals.errorTeamPermissionMissing.title");
            }
          } else if (err.data && err.data.error && err.data.error.code === "GEN-TEAM-CREDITS-USED-UP") {
            if (owner) {
              modal.body = i18n.t("modals.errorTeamPermissionMissing.text.owner");
              modal.title = i18n.t("modals.errorTeamPermissionMissing.title");
              modal.secondaryButtonCb = () => {
                return $h.goTo("Settings", { tab: "team", scroll: true });
              };
              modal.secondaryButtonText = i18n.t("actions.manageSubscription");
            } else {
              modal.body = i18n.t("modals.errorTeamPermissionMissing.text.user");
              modal.title = i18n.t("modals.errorTeamPermissionMissing.title");
            }
            if (err.data.error.creditableType && err.data.error.creditableType === "projects") {
              if (owner) {
                modal.body = i18n.t("modals.errorTeamProjectCreditsUsedUp.text.owner");
                modal.title = i18n.t("modals.errorTeamProjectCreditsUsedUp.title");
                modal.secondaryButtonCb = () => {
                  return $h.goTo("Settings", { tab: "team", scroll: true });
                };
                modal.secondaryButtonText = i18n.t("actions.manageSubscription");
              } else {
                modal.body = i18n.t("modals.errorTeamProjectCreditsUsedUp.text.user");
                modal.title = i18n.t("modals.errorTeamProjectCreditsUsedUp.title");
              }
            } else if (err.data.error.creditableType && err.data.error.creditableType === "users") {
              if (owner) {
                modal.body = i18n.t("modals.errorTeamUserCreditsUsedUp.text.owner");
                modal.title = i18n.t("modals.errorTeamUserCreditsUsedUp.title");
                modal.secondaryButtonCb = () => {
                  return $h.goTo("Settings", { tab: "team", scroll: true });
                };
                modal.secondaryButtonText = i18n.t("actions.manageSubscription");
              } else {
                modal.body = i18n.t("modals.errorTeamUserCreditsUsedUp.text.user");
                modal.title = i18n.t("modals.errorTeamUserCreditsUsedUp.title");
              }
            } else if (err.data.error.creditableType && err.data.error.creditableType === "templates") {
              if (owner) {
                modal.body = i18n.t("modals.errorTeamTemplateCreditsUsedUp.text.owner");
                modal.title = i18n.t("modals.errorTeamTemplateCreditsUsedUp.title");
                modal.secondaryButtonCb = () => {
                  return $h.goTo("Settings", { tab: "team", scroll: true });
                };
                modal.secondaryButtonText = i18n.t("actions.manageSubscription");
              } else {
                modal.body = i18n.t("modals.errorTeamTemplateCreditsUsedUp.text.user");
                modal.title = i18n.t("modals.errorTeamTemplateCreditsUsedUp.title");
              }
            }
          }
          Vue.prototype.$modal.show("error-modal", modal);
        }
      }
      if (err.data && err.data.error && err.data.error.custom) {
        errors.setCustomErrorMessage(err);
      } else {
        if (data && data.custom && err.status === 404) {
          $store.commit("GLOBAL_LOADING_ENDED");
          const path = $router.history.current.path;
          const pathArray = path.split("/");
          const slicedPathArray = pathArray.slice(0, 4);
          const newPath = slicedPathArray.join("/");
          $router.push(newPath);
          if (data.name) {
            Vue.prototype.$snotify.error(i18n.t("toasts.resourceNotFound." + data.name), i18n.t("toasts.error"), {
              timeout: 0,
              icon: Vue.prototype.$errorIcon,
            });
          }
        }
      }
    }
  },
  setCustomErrorMessage: (err) => {
    const modal = $h.formatCustomErrorMessage(err, i18n.locale);
    if (err.data.error.custom.severity === "alert") {
      Vue.prototype.$modal.show("error-modal", modal);
    } else if (err.data.error.custom.severity === "warning") {
      Vue.prototype.$snotify.html(
        '<div class="snotifyToast__title">' +
          modal.title +
          '</div> <div class="snotifyToast__body">' +
          modal.body +
          '</div> <div><img class="snotify-icon" src="' +
          Vue.prototype.$errorIcon +
          '"></div>',
        { type: "error", timeout: 0 }
      );
    }
  },
};

export default errors;
